export function selectAll(selector, root = document) {
  return Array.prototype.slice.call(root.querySelectorAll(selector), 0)
}

export function select(selector, root = document, fallback = 'span') {
  let el = root.querySelector(selector)

  return el ? el : document.createElement(fallback)
}

export function remove(el) {
  let parent = el.parentNode

  if (parent) {
    parent.removeChild(el)
  }
}
